import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class MarcaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let marca = model;
        
        if (!marca.descricao) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }
        if (!validated){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }
        
        return validated;
    }

}